<template>
  <div class="checkbox-container">
    <input
      type="checkbox"
      :id="id"
      :value="props.modelValue"
      :checked="props.modelValue"
      :disabled="props.disabled"
      @change="handleChange"
    />
    <label :for="id">
      <slot></slot>
    </label>
  </div>
</template>

<script setup lang="ts">
import { withDefaults } from 'vue';

interface CheckboxProps {
  id: string;
  modelValue: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<CheckboxProps>(), {
  modelValue: false,
  disabled: false,
});
const emits = defineEmits(['update:modelValue']);

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emits('update:modelValue', target.checked);
};
</script>
<style scoped lang="scss">
input[type='checkbox'] {
  display: none;
}

input[type='checkbox'] + label {
  background: url('@assets/img/contents/ic_check_off.svg') no-repeat center left;
  background-size: 16px;
  height: 16px;
  cursor: pointer;
  font-size: 16px;
  color: #5f6668;
  letter-spacing: -0.65px;
  transition: 0.2s all;
  padding-left: 25px;
}

input[type='checkbox']:checked + label {
  background: url('@assets/img/contents/ic_check_on.svg') no-repeat center left;
  background-size: 16px;
  height: 16px;
}

@media (max-width: 884px) {
  input[type='checkbox'] + label {
    font-size: var(--f14);
  }
}
</style>
